import { render, staticRenderFns } from "./LControlEdit.vue?vue&type=template&id=f72fe41a&scoped=true&"
import script from "./LControlEdit.vue?vue&type=script&lang=js&"
export * from "./LControlEdit.vue?vue&type=script&lang=js&"
import style0 from "./LControlEdit.vue?vue&type=style&index=0&id=f72fe41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72fe41a",
  null
  
)

export default component.exports